import styles from './index.less';
import { FC } from 'react';
import { repairStatusEnum } from '@/pages/RepairManage/config';

interface RepairStepsProps {
  status: string;
}
const RepairSteps: FC<RepairStepsProps> = (props) => {
  const { status } = props;

  const isFinish = (status: string) => {
    switch (status) {
      case repairStatusEnum.PROGRESS:
        return '#E1E2E4';
      case repairStatusEnum.FINISH:
        return '#618CFE';
      default:
        break;
    }
  };

  const Steps: FC<RepairStepsProps> = (props) => {
    const { status } = props;

    return (
      <div className={styles['step-container']}>
        <div
          style={{ background: isFinish(status) }}
          className={styles.point}
        />
        <div
          style={{ background: isFinish(status) }}
          className={styles['big-point']}
        />
        <div
          style={{ background: isFinish(status) }}
          className={styles.point}
        />
      </div>
    );
  };
  return (
    <div className={styles.container}>
      <div className={styles['step-content']}>
        <section>
          <img src={require('@/assets/repairSteps/tijiao.png')} alt={'ti'} />
        </section>
        <p>提交</p>
      </div>
      <Steps status={status} />
      <div className={styles['step-content']}>
        <section>
          <img src={require('@/assets/repairSteps/shenhe.png')} alt={'ti'} />
        </section>
        <p>审核</p>
      </div>
      <Steps status={status} />
      <div className={styles['step-content']}>
        <section>
          <img
            src={require('@/assets/repairSteps/chulizhong.png')}
            alt={'ti'}
          />
        </section>
        <p>处理中</p>
      </div>
      <Steps status={status} />
      <div className={styles['step-content']}>
        <section>
          <img src={require('@/assets/repairSteps/wancheng.png')} alt={'ti'} />
        </section>
        <p>完成</p>
      </div>
    </div>
  );
};

export default RepairSteps;
